import React, { useState } from "react";
import Devices from "./Devices";
import Screens from "./Screens";

const TABS = [
  { label: "Screens", value: "screens", component: <Screens /> },
  { label: "Physical Screens", value: "devices", component: <Devices /> },
];

/**
 * Container for the Screen Management area — mirrors the tabbed pattern used
 * by Account Management. Two tabs: the screen list, and the device inventory
 * (paired + unpaired physical TVs/Pis).
 */
const ScreenManagement: React.FC = () => {
  const [activeTab, setActiveTab] = useState(TABS[0]);

  return (
    <div className="flex-1 m-4 p-2">
      <h1 className="text-2xl font-bold text-gray-800 mb-2">
        Screen Management
      </h1>
      <div className="flex mb-2 border-b-2 border-primary-default">
        {TABS.map((tab) => (
          <button
            key={tab.value}
            className={`px-6 py-2 rounded-t-lg font-medium transition-colors duration-150 ${
              activeTab.value === tab.value
                ? "text-white bg-primary-default"
                : "text-gray-600 bg-gray-100 hover:bg-gray-200"
            }`}
            onClick={() => setActiveTab(tab)}
          >
            {tab.label}
          </button>
        ))}
      </div>
      <div>{activeTab.component}</div>
    </div>
  );
};

export default ScreenManagement;
